// @flow
import { Map as ImmutableMap, Record, List as ImmutableList } from 'immutable';
import type { RecordFactory, RecordOf } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

type VehiclesStoreProps = QcsSyncResourceStoreProps & {};
export const mkVehiclesStore: RecordFactory<VehiclesStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: undefined,
    loadPending: true,

    isLoading: false,
    pendingAmount: undefined,
  });

type OdometerYearProps = {
  year: number,
  odometerStart: number,
  odometerEnd: ?number,
}
export type OdometerYear = RecordOf<OdometerYearProps>;
export const mkOdometerYear: RecordFactory<OdometerYearProps> =
  Record({
    year: undefined,
    odometerStart: undefined,
    odometerEnd: undefined,
  });

// ////////////////////////////////////////////////////////////////////////////////////////////////
// Vehicle - Base Vehicle Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////

type VehicleProps = {
  id: string,
  clientId: ?string,
  isDeleted: ?boolean,
  modifiedAt: ?number,

  name: string,
  make: string,
  model: string,
  year: number,
  isDefault: boolean,
  annualOdometer: ?ImmutableList<OdometerYear>,
  currentValue: number,
  serviceStartOn: string,
  iconType: ?string,

}
export type Vehicle = RecordOf<VehicleProps>;


// ================================================================================================
// Save for __________  Properties & Types
// ================================================================================================

export const mkVehicle: RecordFactory<VehicleProps> =
  Record({
    id: undefined,
    clientId: undefined,
    isDeleted: false,
    modifiedAt: undefined,

    name: undefined,
    make: undefined,
    model: undefined,
    year: undefined,
    isDefault: false,
    annualOdometer: new ImmutableList(),
    currentValue: undefined,
    serviceStartOn: undefined,
    iconType: undefined,
  });

